import { CALENDAR_API_QUERY_EVENT_TYPES } from '@/app/(main)/calendar/consts/calendar-api';
import type { CalendarVisibilityState } from '@/types/calendarTypes';

export type CalendarApiQueryEventType = (typeof CALENDAR_API_QUERY_EVENT_TYPES)[keyof typeof CALENDAR_API_QUERY_EVENT_TYPES];

export function mapCalendarVisibilityToApiEventTypes(
  visibility: CalendarVisibilityState
): CalendarApiQueryEventType[] {
  const eventTypes: CalendarApiQueryEventType[] = [];

  if (visibility.events) {
    eventTypes.push(CALENDAR_API_QUERY_EVENT_TYPES.OUTLOOK);
  }
  if (visibility.birthdays) {
    eventTypes.push(CALENDAR_API_QUERY_EVENT_TYPES.BIRTHDAY);
  }
  if (visibility.tasks) {
    eventTypes.push(CALENDAR_API_QUERY_EVENT_TYPES.TASKS);
  }

  return eventTypes;
}

export function hasCalendarVisibilityEventTypes(visibility: CalendarVisibilityState): boolean {
  return visibility.events || visibility.birthdays || visibility.tasks;
}
